module.exports = __webpack_public_path__ + "img/mainimage_logo.8547a6f9.svg";